/// <amd-module name="Artifacts/Root/protocols/hooks/Protocol" />
import { IProtocolService } from "Artifacts/Root/protocols/services/ProtocolService";
import { IProtocol } from "Artifacts/Root/protocols/types";
import { IPackage } from "Artifacts/Root/types";
import { useMemo } from "react";
import { useComponentContext } from "VSS/Platform/Layout";

/**
 * useProtocol is a hook that provide protocol object based on provided package object.
 *
 * @param pkg Package object
 * @returns Protocol object.
 */
export function useProtocol(pkg?: IPackage): IProtocol | undefined {
  const { pageContext } = useComponentContext();

  const protocol = useMemo(() => {
    const service: IProtocolService = pageContext.getService<IProtocolService>("IProtocolService");
    return pkg ? service.getProtocol(pkg) : undefined;
  }, [pageContext, pkg]);

  return protocol;
}
